import React, { useState } from "react";
import { productData } from "../data/productData";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import toast from "react-hot-toast";

const Products = () => {
  const [data, setData] = useState(productData);
  const [menuOpen, setMenuOpen] = useState(false);
  const [name, setName] = useState("");
  const [apiLink, setApiLink] = useState("");
  const [siteLink, setSiteLink] = useState("");
  const [version, setVersion] = useState("");
  const [created, setCreated] = useState("");
  const [editId, setEditId] = useState(null);
  const [submitted,setSumbitted] = useState(false);

  const handleSubmit = () => {
     setSumbitted(true)
    if(!name || !apiLink || !siteLink || !version || !created){
        toast.error('all Fileds are require')
        return;
    }
    if (editId) {
      const existingItem = data.find((item) => item.id === editId);
      console.log(existingItem);
     const updateData = data.map((item) =>
        item.id === editId
          ? { ...item, name, apiLink, siteLink, version, created }
          : item
      );
      console.log(updateData);
      toast.success('Product Update successfully');
      setData(updateData);
    } else {
      const newData = { id:data.length +1, name, apiLink, siteLink, version, created };
      console.log(newData);
      toast.success('Product add successfully')
      setData([...data, newData]);
    }

    setName("");
    setApiLink("");
    setSiteLink("");
    setVersion("");
    setCreated("");
    setEditId('')
    setMenuOpen(false);
    setSumbitted(false)
    
  };

  const handleEdit = (data) => {
    setEditId(data.id);
    setName(data.name);
    setApiLink(data.apiLink);
    setSiteLink(data.siteLink);
    setVersion(data.version);
    setCreated(data.created);
    setMenuOpen(true);
  };

const handleDelete = (id) =>{
   const deleteItem = data.filter((item) => item.id !== id)
   console.log(deleteItem)
   toast.success('Product deleted Successfully');
   setData(deleteItem)
}

  return (
    <div className=" mt-[10%] md:mt-[4%] px-5">
      <div>
        <div className=" flex justify-between mt-5">
          <div className=" font-bold text-2xl">
            <h4 className=" text-primary ">Product Table</h4>
          </div>
          <button
            className=" rounded-md px-4 py-2 text-sm font-bold bg-third text-primary"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            Add
          </button>
        </div>
        <table className=" w-full mt-5">
          <thead>
            <tr>
              {[
                "S.No",
                "Name",
                "Api Link",
                "Site Link",
                "Version",
                "Created By",

                "Action",
              ].map((col, i) => (
                <th
                  key={i}
                  className=" border-b  font-bold px-4 py-4 text-left text-primary"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((pro, i) => (
              <tr key={i} className=" hover:bg-third  cursor-pointer">
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {i + 1}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {pro.name}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {pro.apiLink}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {pro.siteLink}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {pro.version}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {pro.created}
                </td>

                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  <div className=" flex gap-3">
                    <button onClick={() => handleEdit(pro)}>
                      <CiEdit fontSize={25} />
                    </button>
                    <button onClick={() =>handleDelete(pro.id)}>
                      <MdDeleteOutline fontSize={25} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {menuOpen && (
          <div className=" flex justify-end items-center bg-black bg-opacity-20 inset-0 fixed z-20 ">
            <div className=" bg-white p-6  w-96 rounded-md h-screen ">
              <div className=" flex justify-between mt-5">
                <h4 className=" font-bold text-primary text-xl">
                  Product Detail
                </h4>
                <button
                  className=" hover:text-primary "
                  onClick={() => setMenuOpen(false)}
                >
                  <RxCross2 fontSize={20} />
                </button>
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Name:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {submitted && (
                  <p className=" text-xs font-medium text-red-500">Name is required</p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Api Link:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Api Link"
                  value={apiLink}
                  onChange={(e) => setApiLink(e.target.value)}
                />
                 {submitted && (
                  <p className=" text-xs font-medium text-red-500">Api is required</p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Site Link:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Site Link"
                  value={siteLink}
                  onChange={(e) => setSiteLink(e.target.value)}
                />
                 {submitted && (
                  <p className=" text-xs font-medium text-red-500">Site is required</p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Version:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Version "
                  value={version}
                  onChange={(e) => setVersion(e.target.value)}
                />
                 {submitted && (
                  <p className=" text-xs font-medium text-red-500">Version is required</p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Created By:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter Create By"
                  value={created}
                  onChange={(e) => setCreated(e.target.value)}
                />
                 {submitted && (
                  <p className=" text-xs font-medium text-red-500">Created By is required</p>
                )}
              </div>
              <div className=" mt-5">
                <button
                  className=" bg-primary w-full px-4 py-2 rounded-md text-white text-sm font-semibold"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
